import React from "react";
import "./sobre-historico-style.css";
import CardInfoPos from "../card-historico-pos";

function SobreHistoricoPos(props) {
    const isBrowser = () => typeof window !== 'undefined';

    const handleClick = () => {
        if (!isBrowser()) return;
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };
    console.log('info',props.data)
    return (
        <div className="cards">
            <div className="primeira-col">
                <div>
                    <CardInfoPos data={props.data.historico_disciplinas}/>
                </div>
            </div>
            <button
                onClick={() => handleClick()}
                className="ButtonUp"
            >
                <img alt="arrow" src="/images/ArrowUp.svg"/>
            </button>
        </div>

    );
}

export default SobreHistoricoPos;
